export default __webpack_public_path__ + "static/media/standard-photo-challenge.db014fe1.png";